<template>
  <div>
    <CRow>
      <CCol col>
        <CCard>
          <CCardHeader>
            <strong> Modulo Control Asientos - Listar</strong>
          </CCardHeader>
          <CCardBody>
            <b-row>
    
          
                <b-col sm="12" md="5">
                  <b-form-group>
                    <label>Cliente: </label>
                    <v-select @input="ListControlSeats" placeholder="Seleccione un cliente" class="w-100" :filterable="false" label="full_name" v-model="client" @search="SearchClients" :options="clients"></v-select>
                  </b-form-group>
                </b-col>

                <b-col sm="12" md="2">
                  <b-form-group label="Desde :">
                    <b-form-input @change="ListControlSeats" class="text-center" :max="to" type="date"  ref="to" v-model="from"></b-form-input>
                    <small v-if="errors.from" class="form-text text-danger" >Selccione una fecha</small>
                  </b-form-group>
                </b-col>

                <b-col sm="12" md="2">
                  <b-form-group label="Hasta :">
                    <b-form-input @change="ListControlSeats" class="text-center" :min="from" type="date"  ref="from" v-model="to"></b-form-input>
                    <small v-if="errors.to" class="form-text text-danger" >Selccione una fecha</small>
                  </b-form-group>
                </b-col>
                
                <b-col sm="6" md="2">
                  <b-form-group label=".">
                    <b-input-group>
                    <b-form-input @keyup.enter="ListControlSeats" v-model="search" class="form-control"></b-form-input>
                    <b-input-group-append>
                      <b-button variant="primary" @click="ListControlSeats"><b-icon icon="search"></b-icon></b-button>
                    </b-input-group-append>
                  </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col sm="6" md="1">
                  <b-form-group label=".">
                    <b-link  v-if="Permission('ControlSeatsAdd')" class="btn form-control btn-primary"  :to="{ path: '/control-asientos/nuevo' }" append ><i class="fas fa-file"></i></b-link>
                  </b-form-group>
                </b-col>
        
            </b-row>

            <div class="table-responsive mt-3 height-table">
              <table class="table table-hover table-bordered">
                <thead>
                  <tr>
                    <th width="3%" class="text-center">#</th>
                    <th width="8%" class="text-center">Fecha</th>
                    <th width="8%" class="text-center">Código</th>
                    <th width="40%" class="text-center">Cliente</th>
                    <th width="5%" class="text-center">Moneda</th>
                    <th width="8%" class="text-center">Total</th>
                    <th width="12%" class="text-center">Usuario</th>
                    <th width="7%" class="text-center">Estado</th>
                    <th width="8%" class="text-center">Acciones</th>
                  </tr>
                </thead>
                <tbody v-for="(item, it) in data_table" :key="it">
                  <tr>
                    <td class="text-center">{{ it + 1 }}</td>
                    <td class="text-center"> {{ item.broadcast_date  }}</td>
                    <td class="text-center"> {{ item.code  }}</td>
                    <td class="text-left"> {{ item.client_name+" - "+item.client_document_number  }}</td>
                    <td class="text-center"> {{ item.coin }}</td>
                    <td class="text-right"> {{ item.total }}</td>
                    <td class="text-left"> {{ item.user }}</td>
                    <td class="text-center">
                      <b-badge v-if="item.state == 1" variant="warning">Reservado</b-badge>
                      <b-badge v-if="item.state == 2" variant="success">Realizado</b-badge>
                      <b-badge v-if="item.state == 0" variant="danger">Anulado</b-badge>
                    </td>
                    <td class="text-center">
                      <b-dropdown bloque size="sm" text="Acciones" right>
                        <b-dropdown-item v-if="Permission('ControlSeatsEdit') && item.state == 1" @click="EditControlSeats(item.id_control_seats)" >Editar</b-dropdown-item>
                        <b-dropdown-item v-if="Permission('ControlSeatsView')" @click="ViewControlSeats(item.id_control_seats)" >Ver</b-dropdown-item>
                        <b-dropdown-item v-if="Permission('ControlSeatsDelete')" @click="ConfirmDeleteControlSeats(item.id_control_seats)" >Anular</b-dropdown-item>
                        <b-dropdown-item v-if="Permission('SaleAdd')" @click="AddSale(item.id_control_seats)" >Facturar</b-dropdown-item>
                      </b-dropdown>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <b-row class="mt-4">
              <b-col md="8">
                <b-pagination v-model="currentPage" v-on:input="ListControlSeats" :total-rows="rows" :per-page="perPage" align="center" ></b-pagination>
              </b-col>
              <b-col md="4 text-center">
                <p>Pagina Actual: {{ currentPage }}</p>
              </b-col>
            </b-row>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import vSelect from "vue-select";
import 'vue-select/dist/vue-select.css';
import "vue-select/src/scss/vue-select.scss";

const axios = require("axios").default;
const Swal = require("sweetalert2");
const je = require("json-encrypt");
import { mapState } from "vuex";
import CodeToName from "@/assets/js/CodeToName";
var moment = require("moment");
export default {
  name: "UsuarioList",
  components:{
    vSelect,
  },
  data() {
    return {
      module:'ControlSeats',
      perPage: 15,
      currentPage: 1,
      rows: 0,
      data_table: [],
  
      id_client:0,
      to:moment(new Date()).local().format("YYYY-MM-DD"),
      from:moment().subtract(30, 'days').local().format("YYYY-MM-DD"),
      search: "",
      clients: [],
      client:null,

      errors:{
        to:false,
        from:false,
      }
    };
  },
  mounted() {
    this.ListControlSeats();
  },
  methods: {
    ListControlSeats,
    EditControlSeats,
    ViewControlSeats,
    ConfirmDeleteControlSeats,
    DeleteControlSeats,
    Permission,

    SearchClients,
    AddSale,
  },

  computed: {
    ...mapState(["url_base"]),
    token: function () {
      let user = window.localStorage.getItem("user");
      user = JSON.parse(JSON.parse(je.decrypt(user)));
      return user.api_token;
    },
  },
};

function SearchClients(search, loading) {
  
   let me = this;
    let url = this.url_base + "client/search/" + search;
    if (search !== "") {
      loading(true);
      axios({
        method: "GET",
        url: url,
        headers: { token: me.token, module: me.module, role: 1},
      }).then(function (response) {
            me.clients = response.data;
            loading(false);
      })
    }
}

function ListControlSeats() {

  let search = this.search == "" ? "all" : this.search;
  let id_client = this.client == null ? 'all': this.client.id;
  if (this.from.length == 0) {this.errors.from = true; return false;}
  if (this.to.length == 0) {this.errors.to = true; return false;}
  let me = this;
  let url = this.url_base + "control-seats/list/" + id_client + "/" + this.from + "/" + this.to + "/" + search + "?page=" + this.currentPage;

  axios({
    method: "GET",
    url: url,
    headers: { token: this.token, module: this.module, role: 1,},
  })
    .then(function (response) {
      if (response.data.status == 200) {
        me.rows = response.data.result.total;
        me.data_table = response.data.result.data;
      } else {
        Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
      }
    })
    .catch((error) => {
      Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
    });
}

// Editar usuario
function AddSale(id_control_seats) {
  this.$router.push({
    name: "SaleControlSeatAdd",
    params: { id_control_seats: je.encrypt(parseInt(id_control_seats)) },
  });
}

// Editar usuario
function EditControlSeats(id_control_seats) {   
  this.$router.push({
    name: "ControlSeatsEdit",
    params: { id_control_seats: je.encrypt(parseInt(id_control_seats)) },
  });
}

// Ver Usuario
function ViewControlSeats(id_control_seats) {
  this.$router.push({
    name: "ControlSeatsView",
    params: { id_control_seats: je.encrypt(parseInt(id_control_seats)) },
  });
}

// Confirmar eliminar
function ConfirmDeleteControlSeats(id_control_seats) {
  Swal.fire({
    title: "Esta seguro de anular la reserva?",
    text: "No podrás revertir esto!",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Si, Estoy de acuerdo!",
  }).then((result) => {
    if (result.value) {
      this.DeleteControlSeats(id_control_seats);
    }
  });
}

// eliminar usuario
function DeleteControlSeats(id_control_seats) {
  let me = this;
  let url = this.url_base + "control-seats/delete/" + id_control_seats;
  axios({
    method: "delete",
    url: url,
    headers: {token: this.token, module: this.module,role: 4,},
  })
    .then(function (response) {
       if (response.data.status == 200) {
        const index = me.data_table.map(item => item.id_control_seats).indexOf(response.data.result.id_control_seats);
        me.data_table[index].state = 0;
        // me.data_table.splice(index, 1);
        Swal.fire({ icon: 'success', text: response.data.message, timer: 3000,})
      } else {
        Swal.fire({ icon: 'error', text: response.data.message, timer: 3000,})
      }
    })
    .catch((error) => {
      Swal.fire({ icon: 'error', text: 'A ocurrido un error', timer: 3000,})
    });
}

// permisos
function Permission(module_permission) {
  let user_permissions = window.localStorage.getItem("user_permissions");
  user_permissions = JSON.parse(JSON.parse(je.decrypt(user_permissions)));
  if (user_permissions.indexOf(module_permission) > -1) {
    return true;
  } else {
    return false;
  }
}
</script>
